import pkg from "../../package.json";

interface RuntimeCredentials {
  PHASE?: string;
  USERNAME?: string;
  PASSWORD?: string;
}

export interface AppConfigs {
  appName: string;
  appTitle: string;
  version: string;
  appShortName: string;
  googleMapsKey?: string;
  miscs: {
    durationTimeout: number;
  };
  api: {
    baseURL?: string;
    retry: number;
    timeout: number;
    subscriptionKey?: string;
  };
  localization: {
    defaultLng: string;
    fallbackLng: string;
  };
  credentials:
    | {
        env?: string;
        username?: string;
        password?: string;
      }
    | undefined;
  cryptography: {
    enabled: boolean;
    generationPath: string;
    keyName: string;
    ivName: string;
    includePaths: string[];
    includePathPatterns: string[];
    excludePaths: string[];
    excludePathPatterns: string[];
  };
}

const runtimeCredentials = process.env.credentials as unknown as RuntimeCredentials | undefined;

const appConfigs: AppConfigs = {
  appName: pkg.name,
  appTitle: "Uption",
  version: pkg.version,
  appShortName: "cms",
  googleMapsKey: process.env.GOOGLE_MAPS_KEY,
  miscs: {
    durationTimeout: 4000, // ms
  },
  api: {
    baseURL: process.env.API_BASE_URL,
    retry: 5, // times
    timeout: 5000, // ms
    subscriptionKey: process.env.SUBSCRIPTION_KEY,
  },
  localization: {
    defaultLng: "tr",
    fallbackLng: "tr",
  },
  credentials: runtimeCredentials && {
    env: runtimeCredentials.PHASE,
    username: runtimeCredentials.USERNAME,
    password: runtimeCredentials.PASSWORD,
  },
  cryptography: {
    enabled: process.env.CRYPTO_ENABLED === "true",
    generationPath: "/login/userInfo",
    keyName: "X-Nexus-Crypto-Key",
    ivName: "X-Nexus-Crypto-IV",
    includePaths: [],
    includePathPatterns: [],
    excludePaths: [
      "/login/otp",
      "/login/otp/check",
      "/login",
      "/login/corporateApplication",
      "/login/warmUp",
    ],
    excludePathPatterns: [],
  },
};

export default appConfigs;
